import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./components/PrivateRoute";
import MainLayout from "./layout/MainLayout";
import {
  AgentsPage,
  AurusGroupPage,
  BookingsPage,
  CanceledPlotRequestsPage,
  CompanyTC,
  CouponCodePage,
  CreditsPage,
  CustomersPage,
  Dashboard,
  DebitsPage,
  DeleteUserPage,
  LeadsPage,
  LoginPage,
  NewProjectFormPage,
  NotFoundPage,
  ProjectListingPage,
  ProjectOwnersPage,
  ProjectPlotPage,
  TestimonialsNewsPage,
} from "./pages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="/project-owners" element={<ProjectOwnersPage />} />
            <Route path="/project-listing" element={<ProjectListingPage />} />
            <Route path="/project-listing/add-new-project" element={<NewProjectFormPage />} />
            <Route path="/agents" element={<AgentsPage />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/aurus-group" element={<AurusGroupPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/bookings" element={<BookingsPage />} />
            <Route path="/credits" element={<CreditsPage />} />
            <Route path="/debits" element={<DebitsPage />} />
            <Route path="/company-tc" element={<CompanyTC />} />
            <Route path="/coupons" element={<CouponCodePage />} />
            <Route path={`/testimonials-news`} element={<TestimonialsNewsPage />} />
            <Route path="/canceled-plot-request" element={<CanceledPlotRequestsPage />} />
            <Route
              path="/project-listing/project/:projectId/phase/:phaseId/plot/:plotNumber"
              element={<ProjectPlotPage />}
            />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
          <Route path="/deactivate-account" element={<DeleteUserPage />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
